module.exports = "/_next/static/images/chicago-f06b9315a0ecf9c00547a3c0495a2cac.jpg.webp";